import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { UserAccount } from "model";

/**
* @class NativeAlertHistory
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.nativeAlertHistory[0];
* const alert = new NativeAlertHistory(record);
* @property {NUMBER} _id - The id of the NativeAlertHistory.
* @property {STRING} _type - The type of the NativeAlertHistory.
* @property {STRING} _message - The message of the NativeAlertHistory.
* @property {UserAccount} _userAccount - The userAccount of the NativeAlertHistory.
*/
export default class NativeAlertHistory extends BCMSRecord {
    _id
    _type
    _sendDate
    _message
    _userAccount

    constructor (record){     
      super(record) 
    }
  }
  NativeAlertHistory.define({
    "recordType":"nativeAlertHistory",
    "recordIDProp":"id",
    "className" : "NativeAlertHistory",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id of the NativeAlertHistory
       * @property set {NUMBER} - sets the id of the NativeAlertHistory
       * @memberof NativeAlertHistory
       */
      BCMSRecordProperty.mapToString("id", "_id"),

       /** 
       * @name type
       * @instance
       * @property get {NUMBER} - gets the type of the NativeAlertHistory
       * @property set {NUMBER} - sets the type of the NativeAlertHistory
       * @memberof NativeAlertHistory
       */
        BCMSRecordProperty.mapToString("type", "_type"),

        /** 
       * @name sendDate
       * @instance
       * @property get {NUMBER} - gets the sendDate of the NativeAlertHistory
       * @property set {NUMBER} - sets the sendDate of the NativeAlertHistory
       * @memberof NativeAlertHistory
       */
        BCMSRecordProperty.mapToDate("sendDate", "_sendDate"),

       /** 
       * @name message
       * @instance
       * @property get {NUMBER} - gets the type of the NativeAlertHistory
       * @property set {NUMBER} - sets the type of the NativeAlertHistory
       * @memberof NativeAlertHistory
       */
        BCMSRecordProperty.mapToString("message", "_message"),

        /** 
       * @name userAccount
       * @instance
       * @property get {NUMBER} - gets the id of the NativeAlertHistory
       * @property set {NUMBER} - sets the id of the NativeAlertHistory
       * @memberof NativeAlertHistory
       */
        BCMSRecordProperty.mapToClass("userAccount", "_userAccount", () => UserAccount),
    ]  
})




